module.exports = __webpack_public_path__ + "static/privacy_policy-63a702c1ce6e83618f5202e12a9a83da.pdf";